import {action, observable} from 'mobx';
import {QuizQuestion} from 'main/stores/questions';
import Folder from 'main/stores/folders/Folder';

class Question extends QuizQuestion {
  @observable description;
  @observable uploadToEmployeeProfile;
  @observable attachmentFolder;

  @action merge(other) {
    super.merge(other, {
      attachmentFolder: Folder
    });
  }
}

export default Question;
